// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__klKu9","list":"BalanceDue_list__2BT-j","listRow":"BalanceDue_listRow__1oczl","total":"BalanceDue_total__3uxKb"};